'use strict';

export class ActivateRegistrationCtrl {
    $scope;
    notify;
    jsDataService;
    pageProgress;

    progress = false;
    submitted = false;
    completed = false;
    recaptchaResponse;

    passwordPolicy = {
        is: false,
        minLength: 0,
        includeUpercase: false,
        includeNumber: false,
        includeSymbol: false
    };

    postData = {
        password: '',
        password_repeat: ''
    };

    constructor($scope, jsDataService, notify, pageProgress) {
        'ngInject';
        this.$scope = $scope;
        this.notify = notify;
        this.jsDataService = jsDataService;
        this.pageProgress = pageProgress;

        const g = (typeof window !== 'undefined') ? window : {};
        this.jsDataService.data.submitUrl = g.submitUrl || this.jsDataService.data.submitUrl || '';

        const pp = g.cfgPasswordPolicy || this.jsDataService.get('cfg.passwordPolicy', {});
        const merged = angular.merge({}, this.passwordPolicy, pp);
        merged.is = merged.minLength > 0 || merged.includeUpercase || merged.includeNumber || merged.includeSymbol;
        if (merged.minLength < 1) merged.minLength = 1;
        this.passwordPolicy = merged;
    }

    submitActivation(e) {
        const url = this.jsDataService.get('submitUrl') || (typeof window !== 'undefined' ? window.submitUrl : '');
        if (!url) return;

        const rec = this.jsDataService.get('recaptcha') || (typeof window !== 'undefined' ? window.recaptcha : null);
        if (rec) {
            grecaptcha.ready(() => {
                grecaptcha.execute(rec.siteKey, {action: 'submit'}).then((token) => {
                    this.recaptchaResponse = token;
                    this.submitData(e);
                });
            });
        } else {
            this.submitData(e);
        }
    }

    submitData(e) {
        const url = this.jsDataService.get('submitUrl') || (typeof window !== 'undefined' ? window.submitUrl : '');
        if (!url) return;

        const dat = {...this.postData};
        const rec = this.jsDataService.get('recaptcha') || (typeof window !== 'undefined' ? window.recaptcha : null);
        if (rec) dat[rec.field] = this.recaptchaResponse;

        this.$scope.basicHttpConfigProcess({
            url,
            method: 'POST',
            responseType: 'json',
            data: dat
        }).then((response) => {
            this.progress = false;
            if (response.data && response.data.success) this.completed = true;
            this.submitted = false;
        }, () => {
            this.progress = false;
            this.submitted = false;
        });
    }
}
